module.exports = __webpack_public_path__ + "static/media/icon-cart-disabled.c3e4f0e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/add-to-cart-section/add-to-cart-button/icon-cart-disabled.svg
// module id = 895
// module chunks = 1